export const MyOrdersSection = {
  kyrgyzstan: {
    name: 'my_orders_block.kyrgyzstan',
    key: 'kyrgyzstan',
  },
  tour_appeal: {
    name: 'my_orders_block.tour_requests',
    key: 'tour_appeal',
  },
  tours: {
    name: 'my_orders_block.tour_requests',
    key: 'tours',
  },
  tour_document: {
    name: 'my_orders_block.tours',
    key: 'tour_document',
  },
  avia: {
    name: 'my_orders_block.avia',
    key: 'avia',
  },
  umra: {
    name: 'my_orders_block.umra',
    key: 'umra',
  },
  excursion: {
    name: 'my_orders_block.excursion',
    key: 'excursion',
  },
  bus: {
    name: 'my_orders_block.bus',
    key: 'bus',
  },
  insurance: {
    name: 'my_orders_block.insurance.title',
    key: 'insurance',
  },
}

export const MyOrdersSectionList = Object.keys(MyOrdersSection)?.map((key) => ({
  name: MyOrdersSection[key as MyOrderSectionType].name,
  key: key,
}))

export type MyOrderSectionType = keyof typeof MyOrdersSection

// "tour_requests": "Заявки на туры",
